module.exports = __webpack_public_path__ + "b311820c083f14957dcb377ed40750b2.png";